<template>
    <div class="bbhome">
        <el-card>
            <!-- <el-select v-model="bumen" placeholder="请选择" @change="getList" clearable>
                <el-option label="鲜品事业部" value="鲜品事业部"></el-option>
                <el-option label="养殖事业部" value="养殖事业部"></el-option>
                <el-option label="肉品事业部" value="肉品事业部"></el-option>
                <el-option label="职能部" value="职能部"></el-option>
            </el-select> -->
            
            <br/>
            <br/>

            <el-table
                algin=center
                stripe
                size='mini'
                :cell-style="{fontSize:'12px',borderColor:'black'}" 
                :header-cell-style="{fontSize:'12px',background:'#F5F7FA',borderColor:'black'}"
                border
                :data="list"
                @row-click="(row,column,e)=>go(row)">
                <el-table-column
                    type="index"
                    width="50">
                </el-table-column>
                <el-table-column
                    width="140"
                    label="公司" 
                    prop="yong_org">
                    <template slot-scope="scope">
                        <span>{{ scope.row.yong_org }}</span>
                    </template>
                </el-table-column>

                <el-table-column 
                    label="数量" 
                    prop="carnum" >
                </el-table-column>

                <el-table-column 
                    label="部门" 
                    prop="bumen">
                </el-table-column>
     
            </el-table>
        </el-card>
    </div>
</template>

<script>
import { bblist,powerList } from '../router/api';

export default {
    data() {
        return {
            list:[],
            org:[],
            bumen:'',
            you:'',
        };
    },
    async mounted() {
        await this.getUser()
        await this.getList()   
    },
    methods: {
        async getUser() {
            await powerList({
                id:'',
                name:'',
                tell: localStorage.getItem('ws_tell'),
            }).then(res => {
                var org  = res.data[0].car.split(',')
                this.you  = res.data[0].you.split(',')
                org.map(item=> {
                    this.org.push(item)
                })
            }).catch(err => {
                console.log(err);
            });
        },

        async getList() {
            await bblist({
                bumen:this.bumen
            }).then(res=> {
                if(res.code==1) {
                    if(this.org[0]=='全部' && this.you[0] == '全部') {
                        this.list = res.data
                    } else {
                        this.list = [];
                        for(var i=0; i< res.data.length; i++ ) {
                            for(var j=0;j<this.org.length; j++) {
                                if(this.org[j] ==  res.data[i].yong_org) {
                                    this.list.push({
                                        yong_org: res.data[i].yong_org, 
                                        carnum: res.data[i].carnum, 
                                        bumen: res.data[i].bumen
                                    })
                                }
                            }
                        }
                    }
                    var all = 0
                    this.list.map(item=> {
                        all += item.carnum
                    })
                    this.list.push({
                        yong_org:'合计',
                        carnum:all,
                        mess:'合计'
                    })

                }
            }).catch(err=> {
                console.log(err);
            });
        },
          
        go(row) {
            this.$router.push(`/bblist?org=${row.yong_org}&carnum=${row.carnum}`);
        },
       
    },
};
</script>
<style lang="less" scoped>
.bbhome .main {
    display: flex;
    justify-content: space-between;
    span {
        position: relative;
        top: 6px;
        font-size: 12px;
    }
}
.bbhome .el-table {
    border: solid 1px black
}
</style>

